export const AUTO_POPULATED_PLACES = (eventId?: string | null) => `autoPopulatedAccommodationPlaces_${eventId}`;

export const SHOW_HOTELS_ON_MAP = 20;
export const PICKUP_BEST_HOTELS = 3;
